import React from 'react';

export default ({
    isPrint,
    name,
    even,
    expanded,
    onClick,
}) => {
    if (isPrint) {
        return <li className={`item${even ? " even" : ""}`}>
            <div>
                {name}
            </div>
        </li>;
    }
    return <li className={`item${even ? " even" : ""}`} onClick={onClick}>
        <div>
            <i className={`fa ${expanded ? 'fa-minus' : 'fa-plus'} expando`} />{name}
        </div>
    </li>
};
